import { useEffect } from "react";

import { connect } from "react-redux";
import type { AnyAction, Dispatch } from "redux";

import * as actions from "../../../../store/actions/index";

import { withRouter } from "../../../../shared/utility";

import { useParams } from "react-router-dom";

import { UserDetailsViewModel } from "../../../../viewmodels/setup/users/user/UserDetailsViewModel";
import UserDetailsForm from "../../../../components/forms/user/UserDetailsForm";
import EmptyModal from "../../../../components/modals/EmptyModal";
import type { UserFormValues } from "../../../../components/forms/user/UserDetailsForm";
import type { ResetUserPasswordPayload } from "../../../../types/users";

interface UserDetailsProps { logout: () => void; userType: number }

function UserDetails(props: UserDetailsProps) {
  const { logout } = props;

  const { userId = "" } = useParams<{ userId: string }>();

  const {
    createUser,
    updateUser,
    getUser,
    user,
    loading,
    emptyModal,
    setEmptyModelOpen,
    changeUserPasswordAdmin,
  } = UserDetailsViewModel(logout, userId);

  useEffect(() => {
    if (userId) {
      void getUser();
    }
  }, [userId]); // getUser is scoped to the current route id.

  return (
    <div className="px-4 sm:px-6 lg:px-8 space-y-4">
      <div className="card-custom">
        {loading || (userId && !user) ? null : (
          <UserDetailsForm
            canManageMapping={props.userType === 1}
            isEdit={userId}
            user={user ?? undefined}
            actionCall={(values: UserFormValues) => {
              if (userId) {
                void updateUser(values);
              } else {
                void createUser(values);
              }
            }}
            onResetPassword={(payload: ResetUserPasswordPayload) => {
              if (user) void changeUserPasswordAdmin(user.id, payload);
            }}
          />
        )}
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
    </div>
  );
}

const mapStateToProps = (state: { auth: { userType: number } }) => ({ userType: state.auth.userType });

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
  return {
    logout: () => dispatch(actions.logout()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserDetails));
